.calendarContainer {
  align-items: center;
  display: flex;
  flex-direction: column;
  order: 2;
  padding: 16px 8px;
}
